export const description =
  "Toutes les aides à la rénovation énergétique pour les particuliers en 2026 : MaPrimeRénov’, prime énergie (CEE), éco-PTZ, TVA à 5,5 % et coup de pouce. Conditions, montants, cumuls.";
